import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageTitle } from "../../components/Layout";
import EditorialCalendar from "../../components/EditorialCalendar";
import PostDetailModal from "../../components/PostDetailModal";

export default function CollabCalendar() {
  const [posts, setPosts] = useState([]);
  const [modal, setModal] = useState(null);

  const load = () => api.get("/collab/calendar").then((r) => setPosts(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div>
      <PageTitle overline="Communication" title="Calendrier éditorial" />
      <p className="text-sm text-marine/80 mb-6">Vous voyez ici uniquement les publications où vous êtes identifié(e).</p>
      <EditorialCalendar posts={posts} onPostClick={(p) => setModal(p)} />
      {modal && (
        <PostDetailModal mode="readonly" post={modal} onClose={() => setModal(null)} onSaved={load} />
      )}
    </div>
  );
}
